import type { TypePolicies } from "@apollo/client"
import { InMemoryCache, defaultDataIdFromObject } from "@apollo/client"
import { getObjectTags } from "@/v1-console/object/tag/object.tag.typePolicies"
import { getLandregister }
  from "@/v1-console/cadastre/landregister/cadastre.landregister.typePolicies"
import { getCadastreOwnerships }
  from "@/v1-console/cadastre/ownership/cadastre.ownership.typePolicy"
import { getActivitiesByProjectByNextPrev }
  from "@/v1-console/project/activity/timeline/project.activity.timeline.typePolicy"
import { createActivityTask, removeActivityTask }
  from "@/v1-console/activity/task/activity.task.typePolicy"
import { createActivityNote, removeActivityNote }
  from "@/v1-console/activity/note/activity.note.typePolicy"
import { createProjectObject }
  from "@/v1-console/object/project/add/object.project.add.typePolicy"
import { getCompanySummary }
  from "@/v1-console/company/summary/company.summary.typePolicy"
import { getPersonById }
  from "@/v1-console/person/summary/person.summary.typePolicy"
import { getOccupancyById }
  from "@/v1-console/occupancy/occupancy.typePolicy"
import { ReportPowerbi, getReportPowerbi }
  from "@/v1-console/report/powerbi/report.powerbi.typePolicy"
import { FeatureValueType }
  from "@/v1-console/feature/feature2WithValueType.typePolicy"

const typePolicies: TypePolicies = {
  FeatureValueType,
  ReportPowerbi,
  Query: {
    fields: {
      getObjectTags,
      getLandregister,
      getCadastreOwnerships,
      getActivitiesByProjectByNextPrev,
      getCompanySummary,
      getPersonById,
      getOccupancyById,
      getReportPowerbi
    }
  },
  Mutation: {
    fields: {
      createActivityTask,
      removeActivityTask,
      createActivityNote,
      removeActivityNote,
      createProjectObject
    }
  }
}

type DataObj = {
  Id?: string,
  Code?: string,
  __typename: string
}

const dataIdFromObject = (obj: DataObj) => {
  const id = obj.Id || obj.Code
  return id
    ? `${obj.__typename}:${id}`
    : defaultDataIdFromObject(obj)
}

const cache = new InMemoryCache({
  typePolicies,
  dataIdFromObject
})

export default cache
